module.exports = "../dist/img/product-card-45.38ac.jpg";